<div class="relative">
  <button
    [ngClass]="{ 'bg-[#17233D]': menuState }"
    class="border-0 justify-start items-center flex p-2.5 transition-colors hover:bg-[#17233D] whitespace-nowrap"
  >
    <div class="text-white text-sm font-normal leading-tight mr-1.5">Поддержка</div>
    <div class="flex items-center justify-center">
      <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M7.73831 0.204157C7.71247 0.143494 7.66902 0.0917348 7.61342 0.055404C7.55782 0.0190731 7.49257 -0.000204223 7.42588 1.63161e-06H0.670657C0.603975 -0.000204223 0.538723 0.0190731 0.483124 0.055404C0.427525 0.0917348 0.384067 0.143494 0.358228 0.204157C0.333894 0.265724 0.327721 0.332832 0.340422 0.397717C0.353124 0.462602 0.384182 0.522612 0.430002 0.570804L3.80762 3.90396C3.87218 3.96556 3.95847 4 4.04827 4C4.13808 4 4.22437 3.96556 4.28893 3.90396L7.66654 0.570804C7.71236 0.522612 7.74342 0.462602 7.75612 0.397717C7.76882 0.332832 7.76265 0.265724 7.73831 0.204157Z"
          fill="white"
        />
      </svg>
    </div>
  </button>

  <div
    class="absolute pt-2.5 z-50 transition-all"
    [ngClass]="{
      'opacity-0 -translate-y-[5px] pointer-events-none': !menuState,
      'opacity-100 translate-y-0 pointer-events-auto': menuState,
    }"
  >
    <div
      class="p-6 bg-white rounded-lg shadow flex-col flex-nowrap justify-start items-start inline-flex"
    >
      <div class="text-slate-950 text-2xl font-bold mb-6 whitespace-nowrap">
        Остались вопросы <br />
        или нужна помощь?
      </div>
      <div class="flex-col justify-start items-start flex">
        <div class="flex-col justify-start items-start gap-1 flex mb-4">
          <a href="tel:88005508586" class="text-slate-950 text-base font-bold leading-snug"
            >8 800 550-85-86</a
          >
          <div class="text-slate-600 text-sm font-normal leading-tight whitespace-nowrap">
            Отвечаем с 10 до 19 по МСК
          </div>
        </div>
        <div class="flex-col justify-start items-start gap-1 flex mb-4">
          <a href="mailto:support@rentag.ru" class="text-slate-950 text-base font-bold leading-snug"
            >support&#64;rentag.ru</a
          >
          <div class="text-slate-600 text-sm font-normal leading-tight whitespace-nowrap">
            Напишите сейчас — ответим в рабочее время
          </div>
        </div>
        <div class="flex-col justify-center items-center gap-2 flex">
          <p class="text-center w-full">
            <span class="text-slate-600 text-sm font-normal leading-tight mr-1">или</span>
            <a
              href="https://rentag.ru/faq"
              rel="nofollow"
              title="База знаний"
              target="_blank"
              class="text-slate-600 text-sm font-normal underline leading-tight whitespace-nowrap"
              >воспользуйтесь нашей вспомогательной базой</a
            >
          </p>
        </div>
<!--        <button-->
<!--          (click)="openFeedbackModal.emit(6)"-->
<!--          class="inline-flex items-center justify-center border-none"-->
<!--        >-->
<!--          <svg-->
<!--            class="mr-2"-->
<!--            width="18"-->
<!--            height="18"-->
<!--            viewBox="0 0 24 24"-->
<!--            fill="none"-->
<!--            xmlns="http://www.w3.org/2000/svg"-->
<!--          >-->
<!--            <g clip-path="url(#clip0_4047_1217)">-->
<!--              <path-->
<!--                d="M15.4116 13.6257C15.5154 13.5566 15.6349 13.5145 15.7591 13.5032C15.8834 13.4919 16.0085 13.5118 16.1231 13.561L20.5444 15.542C20.6934 15.6057 20.8177 15.7159 20.8989 15.8562C20.98 15.9964 21.0135 16.1592 20.9944 16.3201C20.8487 17.4086 20.3127 18.4071 19.486 19.13C18.6593 19.8529 17.5982 20.2509 16.5 20.2501C13.1185 20.2501 9.87548 18.9068 7.48439 16.5157C5.0933 14.1246 3.75 10.8816 3.75 7.5001C3.74916 6.40192 4.1472 5.3408 4.87009 4.5141C5.59298 3.6874 6.59152 3.15138 7.68 3.00573C7.84091 2.98661 8.00368 3.02012 8.14395 3.10124C8.28422 3.18236 8.39444 3.30673 8.45813 3.45573L10.4391 7.88073C10.4877 7.99438 10.5076 8.1183 10.4968 8.24146C10.486 8.36463 10.4449 8.48321 10.3772 8.58666L8.37375 10.9689C8.30269 11.0761 8.26066 11.1999 8.25179 11.3283C8.24291 11.4566 8.26749 11.585 8.32313 11.701C9.09844 13.2882 10.7391 14.9092 12.3309 15.677C12.4475 15.7324 12.5766 15.7564 12.7053 15.7467C12.834 15.737 12.958 15.6939 13.065 15.6217L15.4116 13.6257Z"-->
<!--                stroke="#720AA4"-->
<!--                stroke-width="1.5"-->
<!--                stroke-linecap="round"-->
<!--                stroke-linejoin="round"-->
<!--              />-->
<!--            </g>-->
<!--          </svg>-->
<!--          <div class="text-purple-800 text-base font-normal leading-[22.4px] whitespace-nowrap">-->
<!--            Заказать обратный звонок-->
<!--          </div>-->
<!--        </button>-->
      </div>
    </div>
  </div>
</div>
